import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import CategoryGrid from './components/CategoryGrid';
import TrendingTable from './components/TrendingTable';
import GuideSection from './components/GuideSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.living';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'pandabuy.living',
  url: siteUrl,
  description: 'The most trusted pandabuyspreadsheet collection for 2026. Curated fashion, shoes, hoodies, and accessories spreadsheet finds updated daily.',
  publisher: {
    '@type': 'Organization',
    name: 'pandabuy.living',
    url: siteUrl,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <main>
        <Navbar />
        <Hero />
        <WhatIsSection />
        <WhyUseSection />
        <CategoryGrid />
        <TrendingTable />
        <GuideSection />
        <ArticlesSection />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}